const videoArticles = [
  {
    title: "Here’s how the government shutdown could impact Columbia",
    author: "Teniola Adedire, Emily Huang, Katie Chou, Julia Kotch, and Anna Strbka",
    articleLink: "https://youtu.be/kqQl6d7nNd8",
    image: "https://www.columbiaspectator.com/resizer/v2/36Z37AVHYRFCBB75JN2U3EAOFQ.jpeg?auth=d1a45c8d9b2932291618cc96930ebc0d7aeab30324f9e959edf367532f2cc11e",
    youtubeUrl: "https://www.youtube.com/embed/kqQl6d7nNd8"
  }
];
export default videoArticles;